import React from 'react';
import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';
import { rewriteUrl } from '~shared/utils/uriAliases';

/**
 * This class is in replacement of react-router's one.
 * The reason is that we are now using two history objects,
 * the browser one, to handle the localized urls to be displayed
 * to the users, and the memory one, to keep our internal routing
 * the same as before (ie: without having to deal with localization).
 * The issue is that react-router Link component will interact
 * with the history that is passed to <Router>, which in our case
 * is the memory history. The result is that when clicking the links
 * the SPA would update, but not the browser history.
 *
 * This Link component will call navigateTo() to update the browser
 * history.
 *
 * The interface is left the same as the react-router one on purpose.
 *
 * @returns {Element} The Link component
 */
export const Link = ({to, children, className, onClick, gtmAttribute, ...otherProps}) => {
    const onClickCb = (e) => {
        e.preventDefault();

        if (isFunction(onClick)) {
            onClick(e);
        }
    };

    return (
        <a href={rewriteUrl(to)}
            className={className}
            onClick={onClickCb}
            {...otherProps}
            data-spectate-product={gtmAttribute}
        >
            {children}
        </a>
    );
};

Link.propTypes = {
    to: PropTypes.string.isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
    gtmAttribute: PropTypes.string,
    onClick: PropTypes.func,
};
